export default __webpack_public_path__ + "static/media/facial_32.d75c4521.jpg";